import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

import { ContextResponse } from "../../../../../api/index";

export const REQUEST_SESSION_REVIVE = "REQUEST_SESSION_REVIVE";
export const RECEIVE_SESSION_REVIVE = "RECEIVE_SESSION_REVIVE";
export const REQUEST_LOGOUT = "REQUEST_LOGOUT";
export const RECEIVE_LOGOUT = "RECEIVE_LOGOUT";

export const SessionCommonActionFactoryToken: InjectionToken<SessionCommonActionFactory> =  new InjectionToken<SessionCommonActionFactory>("session.common.action.factory");

export interface SessionCommonActionFactory {
    reviveSession(): Observable<ContextResponse>;
    logout(): Observable<ContextResponse>;
}
